<template>
<div class="price-logs">

  <vue-headful
    title="TZ Design Box - Price Logs"
    description="TZ Design Box"
/>

  <div class="container">
    <div class="columns">
      <div class="column is-2 menu-vert">
        <MenuVert :currentactive="'price-logs'" />
      </div>
      <div class="column is-10" style="margin-top:25px;">
        <Breadcrumbs/>
        <hr>
        <div class="content">
          <h2>{{ $t("price-logs") }}</h2>
          <p>{{ $t("price-logs-details") }}</p>
          <b-table
            :data="getPriceLogs"
            :loading="getPriceLogloading"
            paginated
            backend-pagination

            backend-sorting
            default-sort-direction="asc"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"

            :total="getPriceLogTotal"
            :per-page="perPage"
            @page-change="onPageChange"
            @filters-change="filterChanged"

            backend-filtering

            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <b-table-column field="date" label="Date" sortable>
                <template v-slot="props">
                    {{ props.row.date }}
                </template>
            </b-table-column>

            <b-table-column field="kind" label="Kind">
                <template v-slot="props">
                    {{ props.row.kind }}
                </template>
            </b-table-column>

            <b-table-column field="basket_number" label="Basket Number" sortable searchable>
                <template v-slot="props">
                    {{ props.row.basket_number }}
                </template>
            </b-table-column>

            <b-table-column field="article_uid" label="UID" sortable searchable>
                <template v-slot="props">
                    {{ props.row.article_uid }}
                </template>
            </b-table-column>

            <b-table-column field="article_type" label="Type" sortable>
                <template v-slot="props">
                    {{ props.row.article_type }}
                </template>
            </b-table-column>

            <b-table-column field="price" label="Price" sortable searchable>
                <template v-slot="props">
                    {{ props.row.price }}
                </template>
            </b-table-column>

            <b-table-column field="company" label="Company" sortable searchable>
                <template v-slot="props">
                    {{ props.row.company }}
                </template>
            </b-table-column>

            <b-table-column field="contact" label="Contact" sortable searchable>
                <template v-slot="props">
                    {{ props.row.contact }}
                </template>
            </b-table-column>
            <b-table-column field="buttons">
                <template v-slot="props">
                    <router-link
                        class="button"
                        :to="{name: 'price-detail', params: {pid : props.row.id}}"
                    >
                        <font-awesome-icon  style="margin-right:5px" icon="search-plus"></font-awesome-icon> {{ $t("show") }}
                    </router-link>
                </template>
            </b-table-column>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MenuVert       from '@/components/MenuVert'
import Breadcrumbs    from '@/components/Breadcrumbs'
import { mapGetters } from 'vuex'

function debounce(func, wait, immediate) {
	let timeout;
	return function() {
		let context = this, args = arguments;
		let later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		let callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

export default {
    name:'PriceLogs',
    computed: {
        ...mapGetters([
            'getCurrentCompany',
            'getPriceLogs',
            'getPriceLogloading',
            "getPriceLogTotal",
            "getCompany"]),
    },
    data: function(){
        return {
            perPage : 20,
            page:     1,
            sortField: "date",
            sortOrder: "desc",
            filter: {}
        }
    },
    components: {MenuVert, Breadcrumbs},
    methods: {
        onPageChange (pageNum) {
            this.page = pageNum
            this.fetchData ()
        },
        onSort (field, order) {
            this.sortField = field
            this.sortOrder = order
            this.fetchData ()
        },
        filterChanged(filter) {
            this.filter = filter
            this.fetchData ()
        },
        fetchData () {
            let self   = this
            let filter = []
            if (this.filter.article_uid) {
                filter.push ("article_uid=" + this.filter.article_uid)
            }
            if (this.filter.contact) {
                filter.push ("contact=" + this.filter.contact)
            }
            if (this.filter.company) {
                filter.push ("company=" + this.filter.company)
            }
            if (this.filter.basket_number) {
                filter.push ("order_number__contains=" + this.filter.basket_number)
            }
            if (this.filter.price) {
                filter.push ("price=" + this.filter.price)
            }
            console.log ("Price Log Filter", filter)
            this.$store.dispatch(
                "callPriceLogs", {
                    self: self,
                    company: this.getCompany,
                    perPage: this.perPage,
                    pageNum: this.page,
                    sortField : this.sortField,
                    sortOrder : this.sortOrder == "desc" ? "-" : "",
                    filter    : filter.join (":::")
                }
            )
        }
    },
    created () {
      this.debounceFetchData = debounce (this.fetchData,500)
    },
    mounted () {
        this.fetchData ()
    }
}
</script>

<style>
.price-logs{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
.pagination{
    list-style:none!important;
    margin-left:5px!important;
    margin-right:5px!important;
    justify-content: center!important;
}

.page-item{
    margin-left:10px!important;
    margin-right:10px!important;
}

.active{
    background-color: #a72523!important;
    color:#fff!important;
}
</style>
